export const useFiles = async (filetype: string) => {
  // this is a walk around for es lint error
  if (!filetype) {
    return undefined
  }
  return undefined
}
